import { useState } from "react";
import { DialogTitle } from "../shared/modal";
import {
  useAddSavedColorsToCollection,
  useCmsDeleteColor,
  useEditColorCollectionFromSavedColors,
} from "../../../js/api/my-saved-colors/add-saved-colors-to-collection";
import { useAddSavedColorsToCollectionModalStore } from "../../../js/stores/add-saved-colors-to-collection-modal-store";
import { ErrorContent } from "../shared/error-content";
import { LoadingContent } from "../shared/loading-content";
import { LoggedInColorItem } from "./logged-in-color-item";

export function AddSavedColorsToCollectionContent() {
  const [selectedColors, setSelectedColors] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const getSavedColorsToCollectionUrl = useAddSavedColorsToCollectionModalStore(
    (state) => state.getSavedColorsToCollectionUrl
  );
  const closeModal = useAddSavedColorsToCollectionModalStore(
    (state) => state.closeModal
  );
  const { data, isLoading, isError, isFetching } =
    useAddSavedColorsToCollection(getSavedColorsToCollectionUrl);
  const isEmpty = !isLoading && !isFetching && !data?.items?.length;
  const deleteCmsColorMutation = useCmsDeleteColor();
  const onClearAllClick = () => {
    if (data?.clearAllAction?.linkUrl) {
      deleteCmsColorMutation.mutate({
        url: data?.clearAllAction.linkUrl,
      });
    }
  };
  const editColorCollectionMutation = useEditColorCollectionFromSavedColors();
  const mainActionClickHandler = () => {
    if (data?.mainAction?.linkUrl && selectedColors?.length) {
      setIsSubmitting(true);
      const body = {
        CollectionIds: data?.collectionIds || [],
        Codes: selectedColors || [],
      };
      editColorCollectionMutation.mutate({
        url: data?.mainAction?.linkUrl,
        body,
        successHandler: () => {
          setIsSubmitting(false);
          closeModal();
          if (window?.location?.reload) {
            window.location.reload();
          }
        },
        errorHandler: () => {
          setIsSubmitting(false);
          closeModal();
        },
      });
    }
  };

  if (isLoading || isSubmitting) {
    return <LoadingContent />;
  }

  if (isError) {
    return <ErrorContent />;
  }

  return (
    <>
      <div className="saved-colors-header">
        <DialogTitle className="saved-colors-title saved-colors-title--position">
          {data?.modalLabel}
        </DialogTitle>
        {data?.clearAllAction && !isEmpty && (
          <button
            className="saved-colors-tertiary-action saved-colors-tertiary-action--position"
            type="button"
            onClick={onClearAllClick}
          >
            {data?.clearAllAction?.linkLabel}
          </button>
        )}
      </div>
      {isEmpty && (
        <div className="saved-colors-loading-container saved-colors-loading-container--no-top-padding">
          {data?.emptyStateText}
        </div>
      )}
      {!isEmpty && (
        <>
          <div className="saved-colors-main">
            <div className="saved-colors-grid">
              {data?.items?.slice(0, 20)?.map((color) => (
                <LoggedInColorItem
                  key={color.colourCode}
                  name={color.colourName}
                  rgb={color.colourRGB}
                  colourCode={color.colourCode}
                  colourActions={color.colourActions}
                  selectedColors={selectedColors}
                  setSelectedColors={setSelectedColors}
                />
              ))}
            </div>
          </div>
          <div className="saved-colors-footer">
            {data?.secondaryAction && (
              <button
                type="button"
                className="saved-colors-action saved-colors-action--secondary"
                onClick={() => closeModal()}
              >
                {data?.secondaryAction?.linkLabel}
              </button>
            )}
            {data?.mainAction && (
              <button
                type="button"
                className="saved-colors-action saved-colors-action--main"
                onClick={mainActionClickHandler}
              >
                {data?.mainAction?.linkLabel}
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
}
